import { useMemo } from "react";
import { ProductSource } from "reedy-data/models";
import { useSession } from "contexts/AuthContext";
import { query, where, orderBy } from "firebase/firestore";
import {
  getProductsCollection,
  IProduct,
} from "integrations/firebase/collections";
import { useCollectionData } from "react-firebase-hooks/firestore";

export const useManuscripts = () => {
  const { organisation } = useSession();
  const organisationId = organisation.id;

  const manuscriptsQuery = useMemo(() => {
    return query(
      getProductsCollection(),
      where("organisation.id", "==", organisationId),
      where("sourceType", "==", ProductSource.MANUSCRIPT_ONLY),
      orderBy("manuscript.uploadedAt", "desc"),
    );
  }, [organisationId]);

  const [manuscripts = [], loading, error] =
    useCollectionData<IProduct>(manuscriptsQuery);

  return {
    manuscripts,
    loading,
    error,
    hasManuscripts: manuscripts.length > 0,
  };
};
